import React, { useEffect, useMemo, useState } from "react";
import Icon from "../../lib/icon";
import "./ProductFilters.scss";
import api from "../../api";

export default function ProductFilters({
  value = {},                 // текущее состояние фильтров
  filters = [],
  subcategory = null,          // { id, name } | null
  onChange,
  onOpenFilter,
  onOpenLenta,
  sortActive = false,
  onToggleSort
}) {
  // ==========================================================
  // helpers
  // ==========================================================
  function isActive(filterKey) {
    const v = value[filterKey];
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === "object") return v?.from || v?.to;
    return Boolean(v);
  }

  function clearFilter(filterKey) {
    const next = { ...value };
    delete next[filterKey];
    onChange(next);
  }

  function shouldClearOnActive(filterType) {
    return filterType === "Select" || filterType === "Static";
  }

  function getFilterTitle(filter, value) {
    const v = value[filter.key];

    if (v == null) {
      return filter.label;
    }

    // =========================
    // DELIVERY (минуты)
    // =========================
    if (filter.type === "Delivery") {
      if (v === 30) return "до 30 мин";
      if (v === 45) return "до 45 мин";
      if (v === 60) return "до 1 часа";
      if (v === 999) return "больше 1 часа";
      return filter.label;
    }

    // =========================
    // RATING
    // =========================
    if (filter.type === "Static") {
      if (v === 5 || v === 5.0) return "5.0";
      return `от ${v}`;
    }

    // Array (Market, Multi, etc)
    if (Array.isArray(v)) {
      if (v.length === 0) return filter.label;

      const firstLabel = v[0].label;

      if (v.length === 1) {
        return firstLabel;
      }

      return `${firstLabel} +${v.length - 1}`;
    }

    // Price
    if (typeof v === "object") {
      const from = v.from;
      const to = v.to;

      if (from && to) return `${from}–${to} ₽`;
      if (from) return `от ${from} ₽`;
      if (to) return `до ${to} ₽`;

      return filter.label;
    }

    // Single select (Color / Select)
    const opt = filter.meta?.values?.find(x => x.value === v);
    return opt?.label ?? filter.label;
  }


  // ==========================================================
  // render
  // ==========================================================
  return (
    <div className="product-filters">
      <div className="product-filters__header">
        <button
          className={`product-filters__control ${sortActive ? "active" : ""}`}
          onClick={onToggleSort}
        >
          <Icon name="menu" width={24} height={24} />
        </button>

        <button onClick={onOpenLenta} className="product-filters__control">
          <Icon name="sliders" width={24} height={24} />
        </button>

        <div className="product-filters__sort">
          {filters.map(f => {
            const active = isActive(f.key);
            const title = active
              ? getFilterTitle(f, value)
              : f.label;

            return (
              <button
                key={f.key}
                className={`product-filters__chip ${active ? "active" : ""}`}
                onClick={() => {
                  if (active && shouldClearOnActive(f.type)) {
                    clearFilter(f.key);
                  } else {
                    onOpenFilter(f.key);
                  }
                }}
              >
                <span>{title}</span>

                <Icon
                  name={active ? "close" : "chevron-down"}
                  width={20}
                  height={20}
                  color="#C6B2B6"
                />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}